namespace Shared.Infrastructure

open System

[<RequireQualifiedAccess>]
module Int =
    let tryParse (str: string) : int option =
        match Int32.TryParse str with
        | true, num -> Some num
        | _ -> None